import { writable } from '../../_snowpack/pkg/svelte/store.js';

export const jewelleryImagesCurrentIndex = writable(0);
